import React from 'react';

import { Button, ButtonProps, CircularProgress } from '@mui/material';

type LoadingbuttonProps = ButtonProps & {
  loading: boolean;
};

// TODO: Switch to @mui/labs/LoadingButton when upgrade react to versoin 17 and above
const LoadingButton = ({ children, loading = false, ...props }: LoadingbuttonProps) => (
  <Button {...props} disabled={loading}>
    {loading && <CircularProgress size={24} sx={{ mr: 1 }} />}
    {children}
  </Button>
);

export default LoadingButton;
